<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>圈层列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <!-- <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openCircles()">添加</el-button>
            </el-form-item> -->
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="circlesData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <!-- <el-table-column align="center" sortable prop="grade" label="等级" width="120"></el-table-column> -->
            <el-table-column align="center" sortable prop="name" label="圈层名称" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="description" label="描述" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="amount" label="钻石" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="money" label="奖学金" width="100"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="getCirclesxq(scope.row)">查看圈层详情</el-button>
                    <el-button size="mini" type="primary" @click="openCircles(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" disabled @click="deleCircles(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
            <el-form label-width="120px">
                <!-- <el-form-item label="等级" prop="grade">
                    <el-input size="small" v-model="grade" auto-complete="off" placeholder="请输入等级"></el-input>
                </el-form-item> -->
                <el-form-item label="圈层名称" prop="name">
                    <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入圈层名称"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入圈层描述"></el-input>
                </el-form-item>
                <el-form-item label="奖学金" prop="money">
                    <el-input size="small" v-model="money" auto-complete="off" placeholder="请输入奖学金"></el-input>
                </el-form-item>
                <el-form-item label="钻石" prop="amount">
                    <el-input size="small" v-model="amount" auto-complete="off" placeholder="请输入钻石"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addCircles()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upCircles()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 圈层详情 -->
        <el-dialog title="圈层详情页：" :visible.sync="editFormDetails">
            <el-form label-width="120px">
                <!-- <el-form-item label="等级：" prop="grade">
                    <span v-html="this.Details.grade"></span>
                </el-form-item> -->
                <el-form-item label="圈层名称：" prop="name">
                    <span v-html="this.Details.name"></span>
                </el-form-item>
                <el-form-item label="描述：" prop="description">
                    <span v-html="this.Details.description"></span>
                </el-form-item>
                <el-form-item label="奖学金：" prop="money">
                    <span v-html="this.Details.money"></span>
                </el-form-item>
                <el-form-item label="钻石：" prop="amount">
                    <span v-html="this.Details.money"></span>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    {{ transformDate(this.Details.createTime) }}
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getCirclesList } from '../../api/userMG'
import { getCirclesInfo } from '../../api/userMG'
import { addCircles } from '../../api/userMG'
import { deleteCircles } from '../../api/userMG'
import { upCircles } from '../../api/userMG'
export default {
    data() {
        return {
            circlesData: [],
            editFormDetails: false,
            Details: [],
            editFormVisiible: false,
            loading: false,
            name: '',
            description: '',
            grade: '',
            money: '',
            amount: ''

        }
    },
    created() {
        this.getdata(1);
    },
    methods: {
        // 删除
        deleCircles(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deleteCircles(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 修改
        upCircles() {
            this.loading = true,
                upCircles({
                    id: this.id,
                    name: this.name,
                    description: this.description,
                    grade: this.grade,
                    money: this.money,
                    amount: this.amount,
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 添加
        addCircles() {
            this.loading = true,
                addCircles({
                    name: this.name,
                    description: this.description,
                    grade: this.grade,
                    money: this.money,
                    amount: this.amount
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 打开编辑对话框
        openCircles(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改"
                this.id = row.id
                this.name = row.name
                this.description = row.description
                this.grade = row.grade
                this.money = row.money
                this.amount = row.amount
            } else {
                this.tit = "添加"
                this.name = ""
                this.description = ""
                this.grade = ""
                this.money = ""
                this.amount = ""
            }
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 查看圈层详情
        getCirclesxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getCirclesInfo(data).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.Details = res.data.data;
                    return;
                }
            })
        },
        // 获取圈层数据
        getdata(page) {
            this.loading = true;

            getCirclesList().then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.circlesData = res.data.list;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/circles/Circles.vue